import createUserTrackingCookieValue from "./createUserTrackingCookieValue";

export default createUserTrackingCookieValue;
